<template>
    <b-modal
        ref="save-and-proceed-or-reject-modal"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        :title="title"
        hide-footer
    >
        <p>{{ $t('Component(SaveAndProceedOrRefusePrompt):instruction') }}</p>
        <div class="text-right">
            <Button class="mr-1" @click="saveAndProceed">
                {{ $t('Component(Button):save-and-proceed') }}
            </Button>
            <Button variant="danger" class="mr-1" @click="rejectAndProceed">
                {{ $t('Component(Button):reject-and-proceed') }}
            </Button>
            <Button variant="dark" @click="close">{{ $t('Component(Button):close') }}</Button>
        </div>
    </b-modal>
</template>

<script>
import Button from "@core/components/common/Button";
import { BModal } from 'bootstrap-vue'

export default {
    components: {BModal, Button},
    props: {
        title: {
            default() {
                return this.$t('Component(SaveAndProceedOrRefusePrompt):title');
            }
        }
    },
    methods: {
        show() {
            this.$refs['save-and-proceed-or-reject-modal'].show();
        },
        close() {
            this.$refs['save-and-proceed-or-reject-modal'].hide();
        },
        saveAndProceed() {
            this.$emit('saveAndProceed', this.close);
        },
        rejectAndProceed() {
            this.$emit('rejectAndProceed', this.close);
        }
    }
}
</script>
